/**
 * Formats a date for use in URLs
 * 
 * @param {Date} date - JavaScript Date object
 * @returns {string} Date formatted as YYYYMMDD
 */
export const formatDateForUrl = (date: Date | null): string => {
  if (!date) return '';
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  
  return `${year}${month}${day}`;
};

/**
 * Creates a URL for the tips page
 *
 * @param {string} state - State code (e.g., 'vic', 'nsw')
 * @param {string} trackCode - Track code (e.g., 'caulfield', 'randwick', 'new-plymouth')
 * @param {Date|string} date - Date object or string in YYYYMMDD format
 * @param {boolean} isPreview - Whether this is for preview mode
 * @returns {string} Formatted URL for the tips page
 */
export const formatTipsPageUrl = (
  state: string,
  trackCode: string,
  date: Date | string,
  isPreview: boolean = false
): string => {
  if (!state || !trackCode || !date) return '';
  
  // Format the date if it's a Date object
  const formattedDate = date instanceof Date ? formatDateForUrl(date) : date;
  
  // Convert state to lowercase
  const formattedState = state.toLowerCase().replace(/\s+/g, '');
  // Use track code directly (it's already in the correct format)
  const formattedTrack = trackCode.toLowerCase();
  
  if (isPreview) {
    // Preview mode: /preview/{state}/{trackCode}/{date}
    return `/preview/${formattedState}/${formattedTrack}/${formattedDate}`;
  } else {
    // Regular mode: /{state}/{trackCode}/{date}
    return `/${formattedState}/${formattedTrack}/${formattedDate}`;
  }
};
